//
//
//
//
//
//
//

export default {
  name: "showFullscreen-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};